type SkeletonStyles = {
  container?: React.CSSProperties;
  item?: React.CSSProperties;
};

const defaultStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    gap: '8px',
  },
  item: {
    padding: '8px',
  },
};

const keyframes = `
  @keyframes pulse {
    0% {
      opacity: 0.6;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.6;
    }
  }
`;

export const Skeleton = ({ styles }: { styles: SkeletonStyles['item'] }) => (
  <div>
    <style>{keyframes}</style>
    <div
      style={{
        height: '24px',
        backgroundColor: '#e0e0e0',
        marginBottom: '8px',
        borderRadius: '4px',
        animation: 'pulse 1.5s infinite ease-in-out',
        ...styles,
      }}
    />
  </div>
);

type SkeletonListProps = {
  length: number;
  styles?: SkeletonStyles;
};

export const SkeletonList = ({ length, styles }: SkeletonListProps) => {
  return (
    <div style={{ ...defaultStyles.container, ...styles?.container }}>
      {Array.from({ length }).map((_, index) => (
        <Skeleton
          key={index}
          styles={{ ...defaultStyles.item, ...styles?.item }}
        />
      ))}
    </div>
  );
};
